import { configureStore, getDefaultMiddleware } from '@reduxjs/toolkit';

import rootReducer from './root-reducer';

const middleware = [...getDefaultMiddleware()];

const store = configureStore({
  reducer: rootReducer,
  middleware,
  devTools: process.env.REACT_APP_IS_DEVELOPMENT === 'true',
});

export default store;
